import React, { useState, useEffect, useContext, useRef } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Autocomplete,
  AppBar,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function FilterSupplierSearch() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();

  // States for filters inside popup
  const [warehouse, setWarehouse] = useState("");
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // Dummy options for GRN ID search
  const options = ["GRN001", "GRN002", "GRN003"];
  return (
    <>
      <AppBar sx={styles.vg_search_appbar}>
        <Grid container spacing={2} sx={styles.appbar_grid_container}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
            sx={styles.appbar_grid_search}
          >
            <Autocomplete
              freeSolo
              id="sample-search"
              fullWidth
              disableClearable
              options={options}
              slotProps={{
                paper: {
                  sx: {
                    boxShadow: 2,
                  },
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search by Supplier ID"
                  size="small"
                />
              )}
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
            <FormControl variant="outlined" fullWidth size="small">
              <InputLabel>Status</InputLabel>
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                label="Status"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      boxShadow: 2,
                    },
                  },
                }}
              >
                <MenuItem value="Submitted">Submitted</MenuItem>
                <MenuItem value="Returned">Returned</MenuItem>
                <MenuItem value="Accepted">Accepted</MenuItem>
                <MenuItem value="Rejected">Saved</MenuItem>
                <MenuItem value="Rejected">Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
            <LocalizationProvider required dateAdapter={AdapterDayjs}>
              <DatePicker
                id="from-date"
                label="From Date"
                value={fromDate}
                onChange={(newValue) => setFromDate(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
            <LocalizationProvider required dateAdapter={AdapterDayjs}>
              <DatePicker
                id="to-date"
                label="To Date"
                value={toDate}
                onChange={(newValue) => setToDate(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </AppBar>
    </>
  );
}

export default FilterSupplierSearch;
